import { CARDS } from "./cards.js";
import { CASES } from "./cases.js";
import { ORGANIZATIONS } from "./organizations.js";
import { getRegisteredCase } from "./customRegistry.js";
import { getMapNode, getStageOrgPool } from "./stages.js";
import type { CardDefinition, CaseDefinition, NodeDefinition, OrganizationDefinition } from "../domain/types/index.js";

export function getCard(cardId: string): CardDefinition | undefined {
  return (CARDS as Record<string, CardDefinition>)[cardId];
}

export function getCase(caseId: string): CaseDefinition | undefined {
  return (CASES as Record<string, CaseDefinition>)[caseId] ?? getRegisteredCase(caseId);
}

export function getNode(nodeId: string, stageId?: string): NodeDefinition | undefined {
  return getMapNode(stageId, nodeId);
}

export function getOrganization(orgId: string): OrganizationDefinition | undefined {
  return (ORGANIZATIONS as Record<string, OrganizationDefinition>)[orgId];
}

export function listRewardOrganizations(stageId?: string): OrganizationDefinition[] {
  return getStageOrgPool(stageId)
    .map((id) => getOrganization(id))
    .filter((org): org is OrganizationDefinition => Boolean(org));
}
